export default __webpack_public_path__ + "static/media/gamesound.d0521061.mp3";